<template>
<div v-if="tr">
    <div class="row columns">
        <div class="large-3 columns">
            <img class="team-icon-big" v-bind:src="getRosterIcon(tr.team)">
        </div>
        <div class="large-4 columns text-left">
            <div class="match-team-name">
                <router-link v-if="tr.team" :to="{ name: 'TeamDetail', params: { id: tr.team.id.toString() }}">
                    {{tr.team.name}}
                </router-link>
            </div>
            <div class="row columns match-stats"><i class="fa fa-tag" aria-hidden="true"></i> {{tr.team.ref_roster}}</div>
            <div class="row columns match-stats"><i class="fa fa-user" aria-hidden="true"></i> Coachés par {{tr.team.user}}</div>
        </div>
        <div class="large-5 columns text-left">

            <div class="row columns match-stats"><i class="fa fa-hand-peace-o" aria-hidden="true"></i> Supporters : {{tr.supporters}}</div>
            <div class="row columns match-stats"><i class="fa fa-money" aria-hidden="true"></i> gains : {{tr.winnings}} kpO</div>
            <div class="row columns match-stats"><i class="fa fa-thumbs-o-up" aria-hidden="true"></i> Pop : <span v-if="tr.fan_factor==1">+</span> {{tr.fan_factor}} </div>
            <div class="row columns match-stats"><i class="fa fa-bed" aria-hidden="true"></i> Autres Sorties encaissées: {{tr.other_casualties}}</div>
        </div>
    </div>
    <br>
    <div class="row columns">
        <table>
            <thead class="roster-head">
                <tr>
                    <th width="6%">N°</th>
                    <th width="15%">Nom</th>
                    <th width="5%">TD</th>
                    <th width="5%">Réu</th>
                    <th width="5%">Sor</th>
                    <th width="5%">Int</th>
                    <th width="5%">Agro</th>
                    <th width="5%">Expulsion</th>
                    <th width="6%">JPV</th>
                    <th width="18%">Blessure</th>
                </tr>
            </thead>
            <tbody v-if="tr" class="roster">
                <tr v-for="action of tr.player_report" v-if="action.player">
                    <td>{{action.player.num}}</td>
                    <td>{{action.player.name}}</td>
                    <td>{{action.nb_td}}</td>
                    <td>{{action.nb_pass}}</td>
                    <td>{{action.nb_cas}}</td>
                    <td>{{action.nb_int}}</td>
                    <td>{{action.nb_foul}}</td>
                    <td v-if="action.nb_red_card">Oui</td>
                    <td v-else>Non</td>
                    <td v-if="action.mvp">Oui</td>
                    <td v-else>Non</td>
                    <td>{{getWound(action.injury_type)}}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div v-else>
<spinner></spinner>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'DBTeamReportViewer',
  components: {
    spinner
  },
  props: {
    'tr': {}
  },
  data () {
    return {
    }
  },
  computed:
  {
    ...mapGetters({
      playerList: 'playerList'
    })
  },
  methods: {
    getRosterIcon (team) {
      if (team.ref_roster !== undefined) {
        return '/static/imgs/team-icons/' + team.ref_roster.replace(/\s+/, '') + '.png'
      }
      return ''
    },
    getWound (woundId) {
      if (woundId === null) {
        return ''
      }
      if (woundId === 0) {
        return 'commotion'
      }
      if (woundId === 1) {
        return 'manque le prochain match'
      }
      if (woundId === 2) {
        return 'Blessure Persistante'
      }
      if (woundId === 4) {
        return '-1 en Ar'
      }
      if (woundId === 3) {
        return '-1 en Mv'
      }
      if (woundId === 5) {
        return '-1 en Ag'
      }
      if (woundId === 6) {
        return '-1 en Fo'
      }
      if (woundId === 7) {
        return 'R.I.P'
      }
    }
  },
  created () {
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.match-actions-left{
    padding-right: 1.5rem;
}

.match-actions-rihgt{
    padding-left: 1.5rem;
}

.big-title {
    font-size: 1.6rem;
}
.match-team-name {
    font-size: 1.6rem;
}
.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

tr td{
    padding: 0.5rem 0.2rem;
    text-align: center;
    font-size:0.7rem;
}
tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}

button.row{
    margin-left: 0.4rem;
}

.note {
 font-size: 0.6rem;
}

</style>



// WEBPACK FOOTER //
// db-team-report-viewer.vue?94363b36